/* eslint-disable react/prop-types */
import React from 'react';
import PageHeader from '../../TemplateSections/PageHeader/PageHeader';
import PageFooter from '../../TemplateSections/PageFooter/PageFooter';
import PageBody from '../../TemplateSections/PageBody/PageBody';
import PageWrapper from '../../TemplateSections/PageWrapper/PageWrapper';

const TwoColumnLayout = ({
    children,
    pageName,
    overrideAside,
    overrideHeader,
    overrideFooter
}) => (
    <PageWrapper pageName={pageName}>
        <PageHeader customHeader={overrideHeader} />
        <PageBody>
            <div className="vx_row">
                <div className="vx_col-md-7 mainContent-container">
                    {children}
                </div>
                <div className="vx_col-md-5 aside-container">
                    {overrideAside || ''}
                </div>
            </div>
        </PageBody>
        <PageFooter customFooter={overrideFooter} />
    </PageWrapper>
);

export default TwoColumnLayout;
